const filtro = (classificacao) => {
	return classificacao + 'º Lugar'
}

export default filtro
